<template>
  <button 
    v-show="visible" 
    @click="scrollToTop"
    class="back-to-top"
    aria-label="Back to top"
  >
    <Icon name="mdi:chevron-up" />
  </button>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const visible = ref(false);

const handleScroll = () => {
  visible.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--gold) 0%, var(--light-gold) 100%);
  color: var(--navy-blue);
  border: none;
  box-shadow: 0 4px 12px rgba(255, 184, 28, 0.4);
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.back-to-top:hover {
  background: linear-gradient(135deg, var(--light-gold) 0%, var(--gold) 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 184, 28, 0.5);
}

.back-to-top:active {
  transform: translateY(0);
}

/* Adjust position on larger screens to avoid sidebar toggle */
@media (max-width: 1024px) {
  .back-to-top {
    bottom: 80px; /* Position above sidebar toggle if present */
  }
}

@media (max-width: 480px) {
  .back-to-top {
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
    bottom: 16px;
    right: 16px;
  }
}
</style>
